import React, { useEffect, useState } from "react";
import Layout from "../../Layout";
import Container from "../../components/Container";
import { FaTooth, FaEdit, FaTimes, FaChevronDown } from "react-icons/fa";
import { Button, Checkbox, Input, MenuSelect } from "../../components/Form";
import Modal from "../../components/Modals/Modal";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { SiMaterialdesignicons } from "react-icons/si";
import { FaSave } from "react-icons/fa";
import NewExtra from "../../components/NewExtra";
import { IoAdd } from "react-icons/io5";
import { useAppSelector } from '../../store';

import { viewLabProduct, editLabProduct } from "../../api/labProduct";
import { getAllLabMaterials, createLabMaterial } from "../../api/labMaterial";
import { getAllLabProductExtras, createLabProductExtra } from "../../api/labProductExtra";
import { useParams } from "react-router-dom";
import { toast } from 'react-toastify';
import Loader from "../../components/Loader";
import NewMaterial from "../../components/NewMaterial";

function SingleProduct() {
	const data = [{ title: "Extra 1" }, { title: "Extra 2" }, { title: "Extra 3" }];
	const [dropdown, setDropdown] = useState(false);
	const [dropdown2, setDropdown2] = useState(false);
	const [modal, setModal] = useState(false);
	const [modal2, setModal2] = useState(false);
	const [extraModal, setExtraModal] = useState(false);
	const [material, setMaterial] = useState('');

	const { id } = useParams();
	const userData = useAppSelector((state) => state.userData);

	const [loading, setLoading] = useState(false);
	const [pageLoader, setPageLoader] = useState(true);
	const [product, setProduct] = useState([]);
	const [materials, setMaterials] = useState([]);
	const [extras, setExtras] = useState([]);

	const [name, setName] = useState('');
	const [price, setPrice] = useState(0);
	const [productExtras, setProductExtras] = useState([]);
	const [productMaterials, setProductMaterials] = useState([]);
	const [productDentalProcedures, setProductDentalProcedures] = useState([]);

	const fetchData = async () => {
		const productResponse = await viewLabProduct({ productId: id });
		if (productResponse) {
			setProduct(productResponse);
			setName(productResponse.name);
			if (productResponse.price) {
				setPrice(productResponse.price);
			}
			setProductExtras(productResponse.productextras);
			setProductMaterials(productResponse.materials);
			setProductDentalProcedures(productResponse.dentalProcedures);
			// console.log(productResponse);
		}
		const materialResponse = await getAllLabMaterials({ labId: userData?.user?.defaultLabId });
		if (materialResponse) {
			setMaterials(materialResponse);
			// console.log(materialResponse);
			setIsFilterMaterial(!isFilterMaterial);
		}
		const extraResponse = await getAllLabProductExtras({ labId: userData?.user?.defaultLabId });
		if (extraResponse) {
			setExtras(extraResponse);
			// console.log(extraResponse);
			// const filteredExtras = extraResponse.filter(extra => !productExtras.some(productExtra => productExtra._id === extra._id));
			// setExtras(filteredExtras);
			// console.log('filteredExtras', filteredExtras);
			setIsFilter(!isFilter);
		}
		setPageLoader(false);
	};

	useEffect(() => {
		console.log(userData)

		fetchData();
	}, [id]);

	const [isFilter, setIsFilter] = useState(false);

	useEffect(() => {
		const filteredExtras = extras.filter(extra => !productExtras.some(productExtra => productExtra._id === extra._id));
		setExtras(filteredExtras);
		console.log('filteredExtras', filteredExtras);
	}, [modal, isFilter]);

	const [isFilterMaterial, setIsFilterMaterial] = useState(false);

	useEffect(() => {
		const filteredmaterial = materials.filter(material => !productMaterials.some(productMaterial => productMaterial.material._id === material._id));
		setMaterials(filteredmaterial);
		console.log('filteredmaterial', filteredmaterial);
	}, [modal2, isFilterMaterial]);

	const handleExtraAdd = (extra) => {
		console.log(extra);
		const index = productExtras.findIndex((item) => item._id === extra._id);
		if (index === -1) {
			setProductExtras([...productExtras, extra]);
			console.log(productExtras);
			const updatedExtras = extras.filter((item) => item._id !== extra._id);
			setExtras(updatedExtras);
			console.log(updatedExtras);
		} else {
			const updatedExtras = extras.filter((item) => item._id !== extra._id);
			setExtras(updatedExtras);
			console.log(updatedExtras);
		}
	};

	const handleExtraRemove = (extra) => {
		console.log(extra);
		const index = productExtras.findIndex((item) => item._id === extra._id);
		if (index > -1) {
			const updatedExtras = [...extras, productExtras[index]].sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
			setExtras(updatedExtras);
			const updatedProductExtras = productExtras.filter((item) => item._id !== extra._id);
			setProductExtras(updatedProductExtras);
			console.log(updatedExtras);
			console.log(updatedProductExtras);
		}
	};

	const handleCheckChange = (dentalProcedure) => {
		const index = productDentalProcedures.findIndex((item) => item === dentalProcedure);
		if (index > -1) {
			const updatedProductDentalProcedures = [...productDentalProcedures];
			updatedProductDentalProcedures.splice(index, 1);
			setProductDentalProcedures(updatedProductDentalProcedures);
		} else {
			setProductDentalProcedures([...productDentalProcedures, dentalProcedure]);
		}
		console.log(productDentalProcedures);
	};

	const handleMaterialAdd = (material) => {
		console.log(material);
		const index = productMaterials.findIndex((item) => item.material._id === material._id);
		if (index === -1) {
			setProductMaterials([...productMaterials, { material: material, quantity: 1 }]);
			console.log("productMaterials", productMaterials);
			const updatedMaterials = materials.filter((item) => item._id !== material._id);
			setMaterials(updatedMaterials);
			console.log("updatedMaterials", updatedMaterials);
		} else {
			const updatedMaterials = materials.filter((item) => item._id !== material._id);
			setMaterials(updatedMaterials);
			console.log("updatedMaterials", updatedMaterials);
		}
	};

	// const handleMaterialRemove = (material) => {
	// 	console.log(material);
	// 	const index = productMaterials.findIndex((item) => item._id === material._id);
	// 	if (index > -1) {
	// 		const updatedMaterials = [...materials, productMaterials[index]].sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
	// 		setMaterials(updatedMaterials);
	// 		const updatedProductMaterials = productMaterials.filter((item) => item._id !== material._id);
	// 		setProductMaterials(updatedProductMaterials);
	// 		console.log(updatedMaterials);
	// 		console.log(updatedProductMaterials);
	// 	}
	// };

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (!name.trim()) {
			toast.error('Name is required');
			return;
		}

		const data = {
			productId: id,
			name: name,
			price: price,
			productExtras: productExtras,
			materials: productMaterials,
			dentalProcedures: productDentalProcedures,
		};

		console.log(data);

		setLoading(true);
		const response = await editLabProduct(data);
		if (response) {
			setLoading(false);
			setModal(false);
			setModal2(false);
			setPageLoader(true);
			await fetchData();
		}
		setLoading(false);
	};

	const [addExtraLoading, setAddExtraLoading] = useState(false);
	const [newExtra, setNewExtra] = useState({ name: '', price: '' });

	const handleAddNewExtra = async () => {
		if (!newExtra.name.trim()) {
			toast.error('Name is required');
			return;
		}

		setAddExtraLoading(true);
		const response = await createLabProductExtra({ labId: userData?.user?.defaultLabId, name: newExtra.name, price: newExtra.price || 0 });
		if (response) {
			setAddExtraLoading(false);
			setExtraModal(false);
			setNewExtra({ name: '', price: '' });
			setPageLoader(true);
			await fetchData();
			setModal(true);
		}
		setAddExtraLoading(false);
	};

	const [materialModal, setMaterialModal] = useState(false);
	const [newMaterial, setNewMaterial] = useState({ name: '', code: '', unit: '#', description: '' });
	const [addMaterilaLoading, setAddMaterilaLoading] = useState(false);

	const handleAddNewMaterial = async () => {
		if (!newMaterial.name.trim()) {
			toast.error('Name is required');
			return;
		}

		const data = {
			labId: userData?.user?.defaultLabId,
			name: newMaterial.name,
			code: newMaterial.code,
			unit: newMaterial.unit,
			description: newMaterial.description,
		};

		setAddMaterilaLoading(true);
		const response = await createLabMaterial(data);
		if (response) {
			setAddMaterilaLoading(false);
			setMaterialModal(false);
			setNewMaterial({ name: '', code: '', unit: '#', description: '' });
			setPageLoader(true);
			await fetchData();
			setModal2(true);
		}
		setAddMaterilaLoading(false);
	}

	const handleProductMaterialQuantityChange = (e, item) => {
		// console.log(e);
		// return;
		setProductMaterials(productMaterials.map((material) => {
			if (material.material._id === item.material._id) {
				return { ...material, quantity: e.target.value };
			}
			return material;
		}));
		console.log(productMaterials);
	}

	return (
		<Layout>
			{
				pageLoader ?
					<Loader />
					:
					<>
						<Container className="flex flex-col min-w-80 max-w-80 px-5 py-10 items-center bg-white/60 rounded-lg">
							<FaTooth size={44} className="text-gray-900/85" />
							<div className="text-lg my-1">{product.name}</div>
							<div className="text-xs mt-1">price:</div>
							<div className="text-xs mb-4">{price ?? 0} BAM</div>
							<div className="flex flex-col w-full items-center mb-3">
								{
									product.productextras.length > 0
										?
										<>
											<div className="w-full text-start fw-bold">Extras</div>
											{
												product.productextras.map((extra, index) => (
													<>
														<div key={index} className="w-full flex justify-between">
															<div className="text-xs me-3">{extra.name}</div>
															<div className="text-xs">{extra.price} BAM</div>
														</div>
													</>
												))
											}
										</>
										:
										<span className="text-sm text-center">
											<AiOutlineInfoCircle size={18} className="inline-block mr-1" />
											This product don't have additional extras
										</span>
								}
							</div>
							<Button
								className="flex max-w-fit px-4 items-center"
								Icon={() => <FaEdit size={16} />}
								label={"Edit"}
								onClick={() => setModal(true)}
							/>
						</Container>
						<Container className="flex flex-col min-w-80 max-w-80 px-5 py-10 items-center bg-white/60 rounded-lg">
							<SiMaterialdesignicons size={44} className="text-gray-900/85" />
							<div className="text-lg my-1">Materials</div>
							<div className="flex flex-col w-full items-center mb-3">
								{
									product.materials.length > 0
										?
										<>
											{
												product.materials.map((item, index) => (
													<>
														<div key={index} className="w-full flex justify-between">
															<div className="text-xs me-3">{item.material.name} ({item.material.unit})</div>
															<div className="text-xs">{item.quantity}</div>
														</div>
													</>
												))
											}
										</>
										:
										null
								}
							</div>
							<Button
								className="flex max-w-fit px-4 items-center"
								Icon={() => <FaEdit size={16} />}
								label={"Edit"}
								onClick={() => setModal2(true)}
							/>
						</Container>
						<Modal isOpen={modal} closeModal={() => setModal(false)} title={"Edit Product"}>
							<Input label={"Name *"} placeholder={"Metal ceramic, Zirconia, ..."} color={true} value={name} onChange={(e) => setName(e.target.value)} />
							<Input label={"Price (BAM)"} placeholder={"Price"} color={true} type={"number"} min={0} value={price} onChange={(e) => setPrice(e.target.value)} />
							<div className="my-4">
								<div className={`flex flex-1 items-end text-sm w-full my-2`}>
									<div className="flex flex-1 flex-col mr-2">
										<label className={`text-black text-sm`}>Product Extras</label>
										<div className="" onClick={() => setDropdown(!dropdown)}>
											<MenuSelect
												className={
													"w-full bg-transparent text-sm mt-1 p-4 border border-border font-light rounded-lg focus:border focus:border-subMain justify-start"
												}
												datas={extras}
												onClick={handleExtraAdd}
												isMenuOpen={dropdown}
												setIsMenuOpen={setDropdown}
												staticMode>
												<div className="flex flex-wrap justify-start w-full">
													{productExtras.length > 0 ? (
														productExtras.map((extra, index) => (
															<span
																className="mx-2 my-1 bg-slate-200 p-1 cursor-pointer text-sm rounded-lg "
																key={index}
																onClick={() => handleExtraRemove(extra)}>
																{extra.name}
																<FaTimes size={12} className="ms-2 h-full inline" />
															</span>
														))
													) : (
														<span className="text-slate-700">"No extras"</span>
													)}
												</div>
											</MenuSelect>
										</div>
									</div>
									<Button
										className={`flex max-w-fit my-2 px-6 py-2 border border-subMain bg-white !text-subMain items-center`}
										Icon={() => <IoAdd className="font-bold" size={16} />}
										label={"Create New"}
										onClick={() => setExtraModal(true)}
									/>

									<NewExtra
										state={newExtra}
										setState={setNewExtra}
										modal={extraModal}
										setModal={setExtraModal}
										onClick={handleAddNewExtra}
										loading={addExtraLoading}
									/>
								</div>
							</div>
							<div className="">
								<Checkbox
									label={"Crown"}
									className={"my-3"}
									color={true}
									checked={productDentalProcedures.includes("Crown")}
									onChange={() => handleCheckChange("Crown")}
								/>
								<Checkbox
									label={"Bridge"}
									className={"my-3"}
									color={true}
									checked={productDentalProcedures.includes("Bridge")}
									onChange={() => handleCheckChange("Bridge")}
								/>
								<Checkbox
									label={"Full Denture"}
									className={"my-3"}
									color={true}
									checked={productDentalProcedures.includes("Full Denture")}
									onChange={() => handleCheckChange("Full Denture")}
								/>
								<Checkbox
									label={"Skeletal"}
									className={"my-3"}
									color={true}
									checked={productDentalProcedures.includes("Skeletal")}
									onChange={() => handleCheckChange("Skeletal")}
								/>
								<Checkbox
									label={"Misc"}
									className={"my-3"}
									color={true}
									checked={productDentalProcedures.includes("Misc")}
									onChange={() => handleCheckChange("Misc")}
								/>
								<Checkbox
									label={"Inlay"}
									className={"my-3"}
									color={true}
									checked={productDentalProcedures.includes("Inlay")}
									onChange={() => handleCheckChange("Inlay")}
								/>
							</div>
							<Button className={"my-4"} label={"Save"} Icon={FaSave} onClick={handleSubmit} />
						</Modal>
						<Modal isOpen={modal2} closeModal={() => setModal2(false)} title={"Material"}>
							{
								productMaterials.length > 0 ?
									productMaterials.map((item, index) => (
										<div className="flex">
											<Input label={"Name *"} color={true} value={item.material.name} disabled />
											<Input className={"mx-2"} label={"Unit *"} color={true} value={item.material.unit} disabled />
											<Input label={"Quantity *"} type={"number"} min={0} color={true} value={item.quantity ?? 1} onChange={(e) => handleProductMaterialQuantityChange(e, item)} />
										</div>
									))
									:
									null
							}
							<div className="flex h-auto">
								<div className="w-full my-auto mr-2" onClick={() => setDropdown2(!dropdown2)}>
									<MenuSelect
										className="w-full bg-transparent my-auto text-sm mr-2 font-light"
										datas={materials}
										onClick={handleMaterialAdd}
										isMenuOpen={dropdown2}
										setIsMenuOpen={setDropdown2}
										staticMode>
										<div className="flex justify-between">
											{material !== '' ? material : 'Select Material'}
											<div className="flex justify-center items-center">
												<FaChevronDown className="text-gray-500" />
											</div>
										</div>
									</MenuSelect>
								</div>
								<Button className={"my-4"} label={"New Material"} Icon={IoAdd} onClick={() => setMaterialModal(true)} />
								<NewMaterial
									state={newMaterial}
									setState={setNewMaterial}
									modal={materialModal}
									setModal={setMaterialModal}
									onClick={handleAddNewMaterial}
									loading={addMaterilaLoading}
								/>
							</div>
							<Button className={"my-4"} label={"Save"} Icon={FaSave} onClick={handleSubmit} loading={loading} />
						</Modal>
					</>
			}
		</Layout>
	);
}

export default SingleProduct;
